import { render, staticRenderFns } from "./NavbarItaliano.vue?vue&type=template&id=7aa67872&scoped=true&"
import script from "./NavbarItaliano.vue?vue&type=script&lang=js&"
export * from "./NavbarItaliano.vue?vue&type=script&lang=js&"
import style0 from "./NavbarItaliano.vue?vue&type=style&index=0&id=7aa67872&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa67872",
  null
  
)

export default component.exports